// Projets d'amélioration continue (regroupement de chantiers) — gated par CHANTIER:read.
// Distinct des « projets » d'actions collectives des entreprises.
export default [
  {
    path: '/projets',
    name: 'chantiers-projets-list',
    component: () => import('@/views/chantierProjets/ChantierProjetsListView.vue'),
    meta: {
      pageTitle: "Projets d'amélioration continue",
      rights: ['CHANTIER:read'],
      breadcrumb: [
        { text: "Projets d'amélioration continue", active: true },
      ],
    },
  },
  {
    path: '/projets/:id',
    name: 'chantiers-projet-detail',
    component: () => import('@/views/chantierProjets/ChantierProjetDetailView.vue'),
    meta: {
      pageTitle: 'Détail du projet',
      rights: ['CHANTIER:read'],
      breadcrumb: [
        { text: "Projets d'amélioration continue", to: { name: 'chantiers-projets-list' } },
        { text: 'Détail', active: true },
      ],
    },
  },
]
